import { Directive } from '@angular/core';

@Directive({
   // tslint:disable-next-line: directive-selector
   selector: '[actionEnd]'
})
export class ActionEndDirective {

   constructor() { }

}
